import { render, staticRenderFns } from "./search-field.vue?vue&type=template&id=6a08ccd0&scoped=true"
import script from "./search-field.vue?vue&type=script&lang=js"
export * from "./search-field.vue?vue&type=script&lang=js"
import style0 from "./search-field.vue?vue&type=style&index=0&id=6a08ccd0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a08ccd0",
  null
  
)

/* custom blocks */
import block0 from "./search-field.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports